export function formatDate(fecha: Date): string {
  const dia: number = fecha.getDate();
  const mes: number = fecha.getMonth() + 1; // ¡Recuerda que los meses en JavaScript van de 0 a 11!
  const año: number = fecha.getFullYear();

  // Asegurémonos de agregar un cero adelante si el día o el mes son de un solo dígito
  const diaFormateado: string = dia < 10 ? `0${dia}` : `${dia}`;
  const mesFormateado: string = mes < 10 ? `0${mes}` : `${mes}`;

  // Formateamos la fecha como dd/MM/yyyy
  const fechaFormateada: string = `${diaFormateado}/${mesFormateado}/${año}`;

  return fechaFormateada;
}
